import React from "react";
import { useUserContext } from "context/UserContext";
import MembershipManagementBK from "layouts/BK/membershipManagement";
import { isBkLikeRole } from "utils/roleUtils";

function MembershipManagement() {
  const { role } = useUserContext() || {};
  if (isBkLikeRole(role)) {
    return <MembershipManagementBK />;
  }
  return null;
}

export default MembershipManagement;
